<template>
  <div class="statusGroup-main">
    <Menus :menu="menus" @menuClicked="handleMenuClick"></Menus>
    <PopupEntry
      v-if="popupEntryShow"
      :show.sync="popupEntryShow"
      :title="popUpTitle"
      @save="saveStatusGroup" 
      :requiredError="entryError"
      :errorMessages="errorMessage"
      :viewMode="viewMode"
      @requiredClicked="errorMessageClicked"
      :successMessages="successMessages"
      :createdBy = "createdBy"
      :updatedBy="updatedBy"
    >

    <Input
        placeholder="Status Group"
        :isDisabled="disableStatusGroup"
        :inputValue.sync="statusGroup"
        :isRequired="true"
        ref="statusGroup"
        :errorMessage.sync="statusGroupError"
        validator="integer,4"
      />

      <Input
        placeholder="Group Name"
        :isDisabled="disableGroupName"
        :inputValue.sync="groupName"
        :isRequired="true"
        ref="groupName"
        :errorMessage.sync="groupNameError"
        validator="text,50,uppercase,alphanumeric,all"
      />

      <InputQuery
        placeholder="Primary System"
        :isDisabled="disablePrimarySystem"
        :items="systemList"
        itemKey= "System"
        descKey="Application Name"
        :isRequired= "false"
        :selectedObject.sync="selectedSystem"
      ></InputQuery>
      
    </PopupEntry>

    <div class="right-container">
      <TableBox
        title="Status Group"
        :tableData="groupList"
        :selectedRow.sync="selectedGroup"
      ></TableBox>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data: function() {
    return {
      menus: [
      {
          title: "New Status Group",
          icon:
            "https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png",
          key: "MnuNew",
          visible: true,
          enabled: true
        },
        {
          title: "Edit Status Group",
          icon:
            "https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png",
          key: "MnuEdit",
          visible: true,
          enabled: true
        },
        {
          title: "Delete Status Group",
          icon:
            "https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png",
          key: "MnuDelete",
          visible: false,
          enabled: true
        },
        {
          title: "View Status Group",
          icon:
            "https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png",
          key: "MnuQuery",
          visible: true,
          enabled: true
        },
      ],

      // TABLE 
      selectedGroup: [],
      groupList : [],
      systemList : [],
      selectedSystem: null,
      
     // data from API GET
      statusGroup: "",
      groupName: "",

      // Pop up box setting
      popupEntryShow: false,
      popUpTitle: "",
      disableGroupName: false,
      disableStatusGroup: false,
      disablePrimarySystem: false,
      entryError: [],
      errorMessage: [],
      successMessages: [],
      viewMode: false,
      saveOption: "",
      createdBy: "",
      updatedBy: "",
      
      //Error Message
      statusGroupError: "",
      groupNameError: "",
    };
  },
  methods: {

    handleMenuClick: async function(menu) {
      this.errorMessage = [];
      this.entryError = [];
      this.successMessages = [];
      this.clearErrorMessages();

      switch (menu.title) {
        case "View Status Group":
          if (this.selectedGroup.length == 0) {
            this.$showAlert(
              "error",
              "No Status Group Selected",
              "Please select a record to view"
            );
          } else {
            await this.getSpecificGroup(
              this.selectedGroup[0]["Status Group"]
            );
            this.disableGroupName = true;
            this.disablePrimarySystem = true;
            this.disableStatusGroup = true;
            this.viewMode = true;
            this.popUpTitle = "View Status Group";
            this.popupEntryShow = true;
          }
          break;
        case "Edit Status Group":
          if (this.selectedGroup.length == 0) {
            this.$showAlert(
              "error",
              "No Status Group Selected",
              "Please select a record to edit"
            );
          } else {
            await this.getSpecificGroup(
              this.selectedGroup[0]["Status Group"]
            );

            this.saveOption = "E";
            this.disableGroupName = false;
            this.disablePrimarySystem = false;
            this.disableStatusGroup = true;
            this.viewMode = false;
            this.popUpTitle = "Edit Status Group";
            this.popupEntryShow = true;
          }
          break;
        case "New Status Group":
          this.clearInputFields();
          this.saveOption = "N";
          this.disableGroupName = false;
          this.disablePrimarySystem= false;
          this.disableStatusGroup = false;
          this.viewMode = false;
          this.popUpTitle = "New Status Group";
          this.popupEntryShow = true;
          break;
        case "Delete Status Group":
          if (this.selectedGroup.length == 0) {
            this.$showAlert(
              "error",
              "No Status Group Selected",
              "Please select a record to delete"
            );
            return;
          }
          let deleting = await this.$showAlert(
            "warning",
            "Delete Status Group",
            `Are you sure you want to delete Status Group ${
              this.selectedGroup[0]["Status Group"]
            } ?`,
            [
              { text: "Delete", textColor: "white", color: "red" },
              { text: "Cancel", textColor: "black", color: "lightgray" }
            ]
          );

          if (deleting == "Cancel") {
            return;
          }

          
          this.$fullscreenLoading("Deleting Status Group");
          let result = await this.$apiCallV2("/StatusGroup/SaveStatusGroup", {
            action: "D",
            statusgroup: this.selectedGroup[0]["Status Group"]
          });
          this.$fullscreenLoading();
          if (result[0]["Results"] == 0) {
            this.$showAlert(
              "success",
              "Status Group Deleted",
              `Successfully deleted Status Group ${
                this.selectedGroup[0]["Status Group"]
              }`
            );
            this.$nextTick(async () => await this.getAllGroupDetails());
            this.selectedGroup = [];
            return;
          }
          this.$showAlert(
            "error",
            "Status Group NOT Deleted",
            `There was an error deleting Status Group : ${
              this.selectedGroup[0]["Status Group"]
            }`
          );
          
          break;
      }
    },
    getAllGroupDetails: async function() {
      this.$fullscreenLoading("Getting Details");
      this.groupList = [];
      this.groupList = await this.$apiCallV2("/Master/GetListMaster", {
        masterfile: "STATUSGROUP"
      });
      this.$fullscreenLoading();
    },
    getSpecificGroup: async function(record) {
        this.$fullscreenLoading("Getting Details");
        let details = (await this.$apiCallV2(`/Master/GetDetailsMaster`, {
          masterfile: "STATUSGROUP",
          recordid: record
        }))["StatusGroup"];
        this.statusGroup = details["StatusGroup"];
        this.groupName = details["GroupName"];
        this.selectedSystem = this.systemList.getSelected(details["PrimarySystem"],"System");
        this.createdBy = `${details["UserCreated"] || ""} ${details["TimeCreated"]
          ? new Date(details["TimeCreated"]).formatString("dd/MM/yyyy HH:mm")
          : ""
        }`
        this.updatedBy = `${details["UserID"] || ""} ${
          details["DateUpdated"]
          ? new Date(details["DateUpdated"]).formatString("dd/MM/yyyy HH:mm")
          : ""
        }`;

        this.$fullscreenLoading();
    },
    getPrimarySystemList: async function() {
      this.$fullscreenLoading("Getting Details");
      this.systemList = await this.$apiCallV2("/Master/GetListMaster", {
        masterfile: "PRIMARYSYSTEM"
      });
      this.$fullscreenLoading();
    },
    saveStatusGroup: async function() {
      this.entryError = [];
      this.errorMessage = [];
      let isValid = this.checkFields();
      if (isValid) {

        let dataToPost = {
          statusgroup: this.statusGroup,
          groupname: this.groupName,
          primarysystem: this.selectedSystem ? this.selectedSystem["System"] : '',
          action: this.saveOption,
        };

        this.$fullscreenLoading("Saving Status Group");
        let postUpdate = await this.$apiCallV2(
          "/StatusGroup/SaveStatusGroup",
          dataToPost
        );
        this.$fullscreenLoading();

        if (postUpdate[0].Results >= 1) {
          this.errorMessage.push(postUpdate[0].ErrMsg);
        } else {
          if (this.saveOption == "N") {
            this.successMessages.push(
              "Successfully created Status Group : " + this.statusGroup
            );
          }
          if (this.saveOption == "E") {
            this.successMessages.push(
              "Successfully edited Status Group : " + this.statusGroup
            );
          }
          this.viewMode = true;
          this.disable = true;
          this.disableStatusGroup = true;
          this.disableGroupName = true;
          this.disablePrimarySystem = true;
          this.popUpTitle = "View Status Group";
          this.getSpecificGroup(this.statusGroup);
          this.getAllGroupDetails();
          
        }
      }
    },

    errorMessageClicked: function(item) {
      this.$nextTick(() => {
        this.$refs[item].setFocus();
      });
    },
    clearErrorMessages: function() {
      this.groupNameError = "";
      this.statusGroupError = "";
    },
    clearInputFields: function() {
      this.statusGroup = "";
      this.groupName = "";
      this.dateUpdated = "";
      this.selectedSystem= null;
      this.updatedBy = "";
      this.createdBy = "";
    },
    checkFields: function() {

      if (!this.statusGroup || this.statusGroup.trim().length == 0) {
        this.statusGroupError = "Status Group is Required !";
        this.entryError.push({
          key: "statusGroup",
          value: this.statusGroupError
        });
      }

      if(this.statusGroup.trim().length>4){
        this.statusGroupError = "Status Group cannot exceed 4 digits";
        this.entryError.push({
          key: "statusGroup",
          value: this.statusGroupError
        })
      }

      if (!this.groupName || this.groupName.trim().length == 0) {
        this.groupNameError = "Group Name is Required !";
        this.entryError.push({
          key: "groupName",
          value: this.groupNameError
        });
      }

      if(this.groupName.trim().length >50){
        this.groupNameError= "Group Name cannot exceed 50 characters ";
        this.entryError.push({
          key: "groupName",
          value: this.groupNameError
        });
      }
      return this.entryError.length == 0; // return true if entry error length is zero
    }

  },
    
  mounted() {
    this.$bus.$on("pageSASControlAccess", x => {
      if (x.page == "Status Group") {
        x.data.forEach(k => {
          //key in menu same as control value from api
          let selectedMenu = this.menus.find(m => m["key"] == k["Control"]);
          if (selectedMenu) {
            selectedMenu[k["Properties"].toLowerCase()] =
              k["PropertiesValue"] == "True";
          }
        });
      }
    });
    this.getAllGroupDetails();
    this.getPrimarySystemList();
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
@import "@/css/all.scss";
.statusGroup-main {
  padding: 10px 45px;
  font-size: 12px;
  display: flex;

  > .right-container {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    width: 100%;
    margin-left: 5px;
    overflow: hidden;
  }
}
</style>
